// 行业公用数据
import router from '@/router'
import { getHeaderCount, getPurchase, getPurchaser, getPurchaserCategoryDictionary } from '@/utils/api'

// 默认数据表单数据
const defaultDataForm = {
  pageNum: 1,
  pageSize: 10,
  industryType: 1,
  // 标题类型  1项目名称、2中标供应商、3代理机构、4代理机构联系人、5代理机构联系方式、6采购单位、7采购单位联系人、8采购单位联系方式、9评审专家、10品牌、11型号、12服务时长、13物业关键词
  titleType: 1,
  // 搜索标题
  searchTitle: '',
  // 开始时间
  startTime: null,
  // 结束时间
  endTime: null,
  // 搜索金额
  searchMoney: null,
  // 金额类型(1以上2以下)
  moneyType: 1,
  // 搜索省份(字符串)
  searchProvince: '',
  // 排序方式(1公告日期正序2公告日期倒叙3金额正序4金额倒叙)
  sortType: 2,

  // 第三级 采购类别ID
  searchElevatorCategoryId: null,

  searchDataVerifyId: null, //核查的数据id
  // 公用
  searchProjectMarketSegmentIdList: null, // 细分市场ID（公用）,多选,[1, 2, ...]
  searchProjectPurchaseTypeId: null, //采购方式ID（共用）

  // 电梯
  // elevatorCategoryType: 1, // 第一级 (1电梯行业市场划分2电梯行业维保划分3电梯行业更新改造划分4电梯行业加装电梯划分)// 第一级 (1电梯行业市场划分2电梯行业维保划分3电梯行业更新改造划分4电梯行业加装电梯划分)
  elevatorCategoryTypeId: null, // 第二级 purchaserCategoryType的子项ID，如果是全部则为null
  
  // 家具
  searchFurnitureMarketSegmentId: null,  //家具细分市场字典ID
  // 汽车
  searchCarModelId: null, //车型字典ID
  searchCarPurposeIdList: null, //车辆用途字典ID,多选,[1, 2, ...]
  searchCarRemark: "", //车型备注
  searchCarDriveTypeIdList: null, // 车辆动力类型字典ID,多选,[0, 1, ...]
  // 物业
  searchPropertyIndustryId: null, //物业行业字典ID
  // 照明
  lightCategoryType: null,
  lightCategoryTypeId: null,
  searchLightIndustryId: null, //主动筛选某一项照明字典的传参
  // 空调
  searchConditionerProductTypeId: null, //空调产品类型字典ID
  searchConditionerIsWellBeing: null, //空调是否是民生项目(null全部1民生项目0非民生项目)
  // 服务器
  searchServerMarketSegmentId: null, //服务器行业-细分字典ID
  // 视频会议
  searchVideoMarketSegmentId: null, //视频系统行业-细分字典ID
  // 体育
  searchSportPurchaseSegmentIdList: null, //体育行业-体育市场采购细分字典ID,多选,[1, 2, ...]
  searchSportGovernmentSegmentId: null, //体育行业-政府机关采购细分字典ID
  // 医疗
  medicalCategoryType: null,
  medicalCategoryTypeId: null,
}
// 默认图表表单数据
const defaultChartForm = {
  industryType: 1, //行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
  startTime: '', //开始时间
  endTime: '', //结束时间
  searchProvince: null, //搜索省份(字符串)
  searchMoney: null, //搜索金额
  moneyType: 1, //金额类型(1以上2以下)
  queryScope: 3, //1、地图(公用)2、折线图(公用)3、细分市场(公用)4、采购类别(电梯/医疗)5、车型(汽车)6家具、7服务器8、视频9、体育-体育市场10、体育-政府机关11、物业12、照明
  comparisonType: 0, //折线图同比/环比开启方式(0不开启1开启同比2开启环比)
  timeType: 3, //0自定义(不获取环比数据)1月份2季度3年份(不获取环比数据)
  sortType: 1, //1金额排序2数量排序（折线图模式只按照日期正序排列）

  // 公用
  searchProjectMarketSegmentIdList: null, // 细分市场ID（公用）,多选,[1, 2, ...]
  searchProjectPurchaseTypeId: null, //采购方式ID（共用）

  // 电梯
  elevatorCategoryType: null, // 第一级 (1电梯行业市场划分2电梯行业维保划分3电梯行业更新改造划分4电梯行业加装电梯划分)
  elevatorCategoryTypeId: null, // 第二级 purchaserCategoryType的子项ID，如果是全部则为null
  searchElevatorCategoryId: null, // 第三级 采购类别ID
  // 家具
  searchFurnitureMarketSegmentId: null,  //家具细分市场字典ID
  // 汽车
  searchCarModelId: null, //车型字典ID
  searchCarPurposeIdList: null, //车辆用途字典ID,多选,[1, 2, ...]
  searchCarDriveTypeIdList: null, // 车辆动力类型字典ID,多选,[0, 1, ...]
  searchCarRemark: "", //车型备注
  searchIsBigBid: null, // 是否开启大项目(null全部1开启0不开启)
  pageSize: 10, // 大项目限制数量
  // 物业
  searchPropertyIndustryId: null, //物业行业字典ID
  // 照明
  lightCategoryType: null,
  lightCategoryTypeId: null,
  searchLightIndustryId: null, //主动筛选某一项照明字典的传参
  // 空调
  searchConditionerProductTypeId: null, //空调产品类型字典ID
  
  searchConditionerIsWellBeing: null, //空调是否是民生项目(null全部1民生项目0非民生项目)
  // 服务器
  searchServerMarketSegmentId: null, //服务器行业-细分字典ID
  // 视频会议
  searchVideoMarketSegmentId: null, //视频系统行业-细分字典ID
  // 体育
  searchSportPurchaseSegmentIdList: null, //体育行业-体育市场采购细分字典ID,多选,[1, 2, ...]
  searchSportGovernmentSegmentId: null, //体育行业-政府机关采购细分字典ID
  // 医疗
  medicalCategoryType: null,
  medicalCategoryTypeId: null,
}
export default {
  state: {
    // 数据表单
    dataForm: { ...defaultDataForm },
    // 图表表单
    chartForm: { ...defaultChartForm },
    // 采购类别列表
    categoryList: [],
    // 选择的时间，周期
    dateInfo: {
      desc: ''
    },
    // 市场系数
    errorRate: {
      status: 1, // 状态:1开启，0关闭
      value: 150, // 值: 默认为150
    },
    // 图表顶部总数据
    chartCountData: {
      projectMoney: 0, // 中标金额
      projectCount: 0, // 项目数量
      projectWinningBidder: 0, // 中标供应商
    },
    // 表格标题
    chartTableTitle: '',
    // 细分市场列表
    marketSegmentList: [],
    // 采购方式列表
    purchaseTypeList: [],
  },
  getters: {},
  mutations: {
    // 设置表单数据
    setDataForm(state, data) {
      state.dataForm = { ...state.dataForm, ...data }
    },
    // 重置表单数据
    resetDataForm(state) {
      let sortType = router.currentRoute.query.activeTab == 2 ? 4 : 2
      state.dataForm = {
        ...defaultDataForm,
        sortType,
        industryType: +router.currentRoute.query.industryType
      }
    },
    // 设置采购类别列表
    setCategoryList(state, data) {
      state.categoryList = [...data]
    },
    // 设置选择的时间，周期
    setDateInfo(state, data) {
      state.dateInfo = { ...state.dateInfo, ...data }
    },
    // 设置表单数据
    setChartForm(state, data) {
      state.chartForm = { ...state.chartForm, ...data }
    },
    // 重置表单数据
    resetChartForm(state) {
      state.chartForm = {
        ...defaultChartForm,
        industryType: +router.currentRoute.query.industryType
      }
    },
    // 设置市场系数
    setErrorRate(state, data) {
      state.errorRate = { ...state.errorRate, ...data }
    },
    // 设置图表顶部总数据
    setChartCountData(state, data) {
      state.chartCountData = { ...data }
    },
    // 设置表格标题
    setChartTableTitle(state, data) {
      state.chartTableTitle = data
    },
    // 设置细分市场列表
    setMarketSegmentList(state, data) {
      state.marketSegmentList = [...data]
    },
    // 设置采购方式列表
    setPurchaseTypeList(state, data) {
      state.purchaseTypeList = [...data]
    }
  },
  actions: {
    // 获取采购类别列表
    async getCategoryList({ commit, state }) {
      let [err, res] = await getPurchaserCategoryDictionary(state.dataForm.industryType)
      if (err) return
      commit('setCategoryList', res)
    },
    // 获取图表总数据
    async getChartCountData({ commit, state }) {
      let data = { ...state.chartForm }
      // 处理金额问题
      if (!data.searchMoney) data.searchMoney = null
      else data.searchMoney = data.searchMoney * 1e6
      // 如果开启了大项目，不需要排序，目前使用（汽车）
      if (data.searchIsBigBid) data.sortType = null

      let [err, res] = await getHeaderCount(data)
      if (err) return
      let e = state.errorRate.value / 100

      // 公共数据，真实数据乘市场系数
      let publicSata = {
        modifyProjectMoney: res.projectMoney * e,
        modifyProjectCount: res.projectCount * e,
        modifyProjectWinningBidder: res.projectWinningBidder * e,
      }
      // 民生项目数据，真实数据乘市场系数，（空调）
      let wellBeingData = {}
      if (data.industryType === 6) {
        wellBeingData = {
          modifyWellBeingProjectMoney: res.wellBeingProjectMoney * e,
          modifyWellBeingProjectCount: res.wellBeingProjectCount * e,
          modifyWellBeingProjectWinningBidder: res.wellBeingProjectWinningBidder * e,
        }
      }
      commit('setChartCountData', { ...res, ...publicSata, ...wellBeingData })
    },
    // 获取细分市场列表
    async getMarketSegment({ commit }) {
      let [err, res] = await getPurchaser()
      if (err) return
      commit('setMarketSegmentList', res)
    },
    // 获取细分市场列表&采购方式列表
    async getPurchaseType({ commit }) {
      let [err, res] = await getPurchase()
      if (err) return
      commit('setPurchaseTypeList', res)
    },
  },
}
